<template>
  <div class="task_pop_bg">
    <!-- 标题 -->
    <div class="topSpot"></div>
    <div class="bottomSpot"></div>
    <div class="topBorder">
    </div>
    <div class="titleLine">
      <div class="info_title">
        <div class="titleLine_name"><span class="leftLine"></span><span style="color: #2ac1ff;">{{getEarlymsg.typeName}}</span></div>
        <div class="closeBtn" @click="close"></div>
      </div>  
    </div>
    <div class="middleOutLine" style="width:100%;overflow:hidden;padding:0 10px;">
    <el-form  :model="ruleForm" :rules="rules"  ref="ruleForm">
      <div class="notisfy">{{resultData.content}}</div>
      <el-form-item label="">
        <el-upload
          action="#"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :http-request="uploadAvatar"
          :before-upload="beforeAvatarUpload"
          :file-list="fileList"
          :disabled="!IsEdit"
        >
          <i class="addIcon"></i>
          <i slot="default" class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-form-item> 
      <el-form-item prop="content">
        <el-input
          type="textarea"
          v-model="ruleForm.content"
        ></el-input>
      </el-form-item>
      <el-form-item prop="confirmType">
        <el-radio-group v-model="ruleForm.confirmType">
           <el-radio  label="0" border>经检查为误报</el-radio>
           <el-radio  label="1" border>已处理完毕</el-radio>
        </el-radio-group> 
      </el-form-item>
      <el-form-item style="margin-top:10px;display:flex;justify-content:flex-end;">
        <el-button @click="submitForm('ruleForm')">确认</el-button>
      </el-form-item>
    </el-form>
    </div>
    <div class="bottomBorder"></div>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import waitAll from "../../../../../../utils/src/waitAll";
 import {handleMsg,getMsgInfo} from '../../../../../../request/msgApi';
 import { mapGetters,mapState} from 'vuex';
export default {
  data() {
    return {
      ruleForm: {
        confirmType:"",
        content:"",
      },
      rules: {
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        confirmType: [{ required: true, message: "请选择处理方式", trigger: "change" }]
      },
      IsEdit: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imgList: [],
      fileList: [],
      delFileList: [],
      currentValue: "",
      preValue: "",
      resultData:{}
    };
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
     },
    ...mapState({
        'getEarlymsg':state => state.earlyMsg
     }),
  },
  created: function() {

  },
  mounted: function() {
   
  },
  methods: {

    close(){
     this.$emit("closeFrom",false)
    },
    handleRemove(file, fileList) {
      // console.log(file);
      // console.log(fileList)
      // console.log(this.fileList)
      let that = this;
      if (file.FileUrl) {
        // 最后提交的时候再删除
        this.delFileList.push(file);
        this.fileList.forEach((item) => {
          if (item.FileUrl == file.FileUrl) {
            item.Validity = 0;
          }
        });
      }
      let arr = [];
      fileList.forEach((item) => {
        if (that.$route.query.type == "edit") {
          if (!item.FileUrl) {
            arr.push(item.raw);
          }
        } else {
          arr.push(item.raw);
        }
      });
      this.imgList = arr;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    uploadAvatar(item) {
      this.imgList.push(item.file);
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    save() {
      let that = this;
      let uuid = ZJApp.ZJUtils.uuid();
      //先上传图片
      that.uploadAttch(uuid).then((r) => {
        console.log("图片结果")
        console.log(r)
        that.saveData(r);
      });
    },
    saveData(r) {
      let imgUrlList = [];
      //如果有图片
      if (r && r.length > 0) {
        r.forEach((item) => {
          imgUrlList.push(item.DownloadPath);
        });         
      }  
      let that = this;
      let params={
            "id":that.getEarlymsg.id,
            "type":"0", // 类型(0人工处理，1、转任务， 2、转应急)
            "handler":ZJApp.ZJUser.current.UserName,
            "handlerId":"",
            "confirmType":this.ruleForm.confirmType,
            "content":that.ruleForm.content,
            "videos":"",
            "audios":"",
            "images":imgUrlList.join(","),
            "sourceId":"" //关联任务id，非必传
        }
        handleMsg(params).then(res=>{
          console.log("人工处理预警结果")
          console.log(res)
          if(res.code==0){
            that.close();
          }
        })
      
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
    //插入附件
    uploadAttch(feedid) {
      return new Promise((resolve, reject) => {
        let mediaList = this.imgList;
        var arr = [];
        mediaList.forEach((item) => {
          var option = {
            file: item,
            data: {
              module: "unifiedRelease", //模块名
              submodule: "Announcement", //子模块
              assocID: feedid, //业务ID
              uploader: ZJApp.ZJUser.current.UserName, //上传人
            },
            onProgress: () => {},
            onSuccess: () => {},
            onError: () => {},
          };
          arr.push(this.httpRequest(option));
        });

        waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
  }
  
};
</script>
<style scoped lang="scss">
  .task_pop_bg{
    width:36.5%;
    position: fixed;
    left:50%;
    top:180px;
    z-index: 10000;
    margin-left:-18.2%;
    box-sizing: border-box;
    border-bottom-left-radius: 22px;
    .topBorder{
      width:100%;
      // height:34px;
      // padding-top:64px;
      height:34px;
      background: url("../../../../../../assets/pops.png") no-repeat;
      background-size: 100% 34px;
      position:relative;
    }
    .bottomBorder{
      width:100%;
      height:25px;
      background: url("../../../../../../assets/popBottom.png") no-repeat;
      background-size: 100%;
    }
    .titleLine{
      width:100%;
      box-sizing: border-box;
      background:rgba(26,49,70,0.3);
      border-left: 1px solid #2ac1ff;
      border-right: 1px solid #2ac1ff;
      padding-bottom: 10px;    
      .info_title{  
        width:92%;
        margin:0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px dashed #2ac1ff;
        padding-bottom: 10px;
      }
      .titleLine_name{
        display: flex;
        align-items: center;
        .leftLine{
          display:inline-block;
          width:2px;
          height:15px;
          margin-right:10px;
          background: #2ac1ff;
        }
      }
      .closeBtn{
        width:20px;
        height:20px;
        background: url("../../../theme-default/src/img/close.png") no-repeat;
        background-size:20px;
      }
    }
    .middleOutLine{
      border-left:0.5px solid #2ac1ff;
      border-right:0.5px solid #2ac1ff;
       background:rgba(26,49,70,0.3);
    }
    .notisfy{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 3%;
        font-size: 16px;
        margin-bottom:15px;
    }
    .topSpot{
      width:222px;
      height:125px;
      background:url("../../../../../../assets/spot.png") no-repeat;
      position:absolute;
      right:15px;
      top:-62px;
      z-index:12000;
    }
    .bottomSpot{
      width:222px;
      height:120px;
      background:url("../../../../../../assets/spot.png") no-repeat;
      // background-size:cover;
      position:absolute;
      left:-35px;
      bottom:-45px;
       z-index: 10000;
    }
}
</style>
